import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, Divider, Paper, Typography, useTheme } from '@mui/material';
import { useContext, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Footer from '@/components/Footer';
import Header from '@/components/header/Header';
import { LocaleContext } from '@/Contexts/LocaleContext';

export default function SubmitConfirmation() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { translatedText } = useContext(LocaleContext);

  const submittedApplicationId = useMemo(() => {
    const stateApplicationId = (location.state as { applicationId?: number | string } | null)
      ?.applicationId;

    const parsedId = Number(stateApplicationId);
    return Number.isFinite(parsedId) && parsedId > 0 ? parsedId : null;
  }, [location.state]);

  const handleReviewApplication = () => {
    if (submittedApplicationId != null) {
      navigate(-1);
      return;
    }

    navigate('/dashboard');
  };

  return (
    <Box display='flex' flexDirection='column' minHeight='100vh' width='100vw'>
      <Header />
      <Divider
        sx={{
          borderWidth: '1px',
          borderColor: theme.palette.sandShade3.main,
        }}
      />

      <Box display='flex' flex={1} alignItems='center' justifyContent='center' px={2} py={4}>
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            maxWidth: '700px',
            border: '1px solid',
            borderColor: theme.palette.sandShade2.main,
            borderRadius: 2,
            p: { xs: 3, sm: 4 },
            backgroundColor: theme.palette.sandShade1.main,
          }}
        >
          <Box display='flex' alignItems='center' gap={1.5} mb={2}>
            <CheckCircleIcon color='success' />
            <Typography variant='h4'>{translatedText.submitConfirmation.title}</Typography>
          </Box>

          <Typography variant='body1' mb={3}>
            {translatedText.submitConfirmation.message}
          </Typography>

          <Box display='flex' justifyContent='center' gap={2} flexWrap='wrap'>
            <Button variant='secondary' onClick={handleReviewApplication}>
              {translatedText.submitConfirmation.reviewApplication}
            </Button>
            <Button variant='primary' onClick={() => navigate('/dashboard')}>
              {translatedText.submitConfirmation.backToDashboard}
            </Button>
          </Box>
        </Paper>
      </Box>

      <Footer />
    </Box>
  );
}
